// src/modules/app-views/_apps/appmulti/orders/pages/Init/components/expandedRow.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Table } from 'antd';
import dayjs from 'dayjs';
import { FaPlaneDeparture, FaPlaneArrival } from 'react-icons/fa';
import translateX from 'utils/translateX';

// *******************************************************************************
// GLOBAL VARIABLES
// *******************************************************************************
const STYLES = {
  depArr: { marginRight: 4 },
};

// *******************************************************************************
// EXPANDED ROW RENDER
// *******************************************************************************
const expandedRow = record => {
  const columns = [
    {
      key: 'code',
      title: translateX('code'),
      render: () =>
        (record?.__plan?._metadata?.__documentCode || '').toUpperCase() || '—',
    },
    {
      key: 'plan',
      title: translateX('plan'),
      render: () =>
        `${record?.__plan?.name || '—'} — ${record?.__operator?.name || '—'}`,
    },
    {
      key: 'destiny',
      title: translateX('destiny'),
      render: () => (record?.destiny ? translateX(record.destiny) : '—'),
    },
    {
      key: 'dates',
      title: translateX('travel_period'),
      render: () => (
        <span>
          <FaPlaneDeparture style={STYLES.depArr} />
          {record?.departure ? dayjs(record.departure).format('L') : '—'}
          {'  '}
          <FaPlaneArrival style={STYLES.depArr} />
          {record?.arrival ? dayjs(record.arrival).format('L') : '—'}
        </span>
      ),
    },
    {
      key: 'passengers',
      title: translateX('travellers'),
      render: () =>
        (record?.travellers || [])
          .map(t => `${t.name || '—'}, ${t.ageInTravelDate ?? ''}`)
          .join(' · ') || '—',
    },
  ];

  return (
    <Table
      size="small"
      pagination={false}
      rowKey="key"
      dataSource={[{ key: record._id }]}
      columns={columns}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default expandedRow;
